<template>
  <iframe
    :src="link"
    frameborder="0"
    class="h-screen w-full"
  />
</template>

<script>
import { computed, onMounted, onUnmounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const getBaseUrl = (url) => {
  const paths = url.split('/');
  const protocol = paths[0];
  const host = paths[2];
  return `${protocol}//${host}`;
};

const GoersWidgetMessage = {
  ORDER_SUCCEED: 'order-succeed',
};

export default {
  setup() {
    const route = useRoute();
    const router = useRouter();

    const link = computed(() => route.query.link);

    function handleMessage(event) {
      if (event.origin === getBaseUrl(link.value)) { // only handle from iframe src
        if (event.data.type === GoersWidgetMessage.ORDER_SUCCEED) {
          router.push({ name: 'ORDER_SUCCEED' });
        }
      }
    }

    onMounted(() => {
      window.addEventListener('message', handleMessage);
    });

    onUnmounted(() => {
      window.removeEventListener('message', handleMessage);
    });
    return {
      link,
    };
  },
};
</script>
